<template>
  <div class="float-right">
    <v-btn
      v-if="receiverInfo && receiverInfo.length"
      icon
      large
      @click.stop="fileBtnClick"
    >
      <v-icon color="deep-orange lighten-2">
        {{ mdiFileDocument }}
      </v-icon>
    </v-btn>

    <v-dialog
      v-model="dialog"
      max-width="250"
    >
      <v-list>
        <v-list-item
          v-for="item in receiverInfo"
          :key="item.receiverProcessId"
          @click="dialog = false; $emit('previewFile', getTheFirstId(item.receiverProcessIds))"
        >
          <v-list-item-content>
            <v-list-item-title>{{ momentWithHyphen(item.processCreatedTime).format('YYYY-MM-DD HH:mm') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-dialog>
  </div>
</template>

<script>
import { mdiFileDocument } from '@mdi/js'
import { momentWithHyphen } from '@/utils/datetimeUtil'

export default {
  props: {
    receiverInfo: {
      type: Array,
      default: null
    }
  },
  data: function () {
    return {
      mdiFileDocument: mdiFileDocument,
      dialog: false
    }
  },
  methods: {
    fileBtnClick () {
      if (this.receiverInfo.length > 1) {
        this.dialog = true
      } else {
        this.dialog = false
        this.$emit('previewFile', this.getTheFirstId(this.receiverInfo[0].receiverProcessIds))
      }
    },

    getTheFirstId (processIds) {
      let idList = processIds == null ? '' : processIds.split(',')
      return idList[0]
    },

    momentWithHyphen
  }
}
</script>
